import { render, staticRenderFns } from "./DeviceAllocate.vue?vue&type=template&id=809b55ea"
import script from "./DeviceAllocate.vue?vue&type=script&lang=js"
export * from "./DeviceAllocate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports